export const GET_PAYABLE_LIST = `${BACKOFFICE_API_URL}/payables`
export const GET_PAYABLE_DETAILS = `${GET_PAYABLE_LIST}/:id`
export const APPROVE_PAYABLE_REQUEST = `${GET_PAYABLE_DETAILS}/approve`
export const CANCEL_PAYABLE_REQUEST = `${GET_PAYABLE_DETAILS}/cancel`
